<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <el-button type="text" @click="goLogin" style="float: left;color: #999;" icon="el-icon-arrow-left">
                返回登录页
            </el-button>
            <div class="protocol-header">
                <h1>智步云上模型网隐私政策</h1>
            </div>
            <div class="protocol-content">
                <!-- 这里放置服务协议的具体内容 -->
                <div class="protocol-section">
                    <p>欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全可控。基于此，智步云上模型网上交易平台服务提供者（或简称“我们”）制定本《智步云上模型网上交易平台隐私政策》（下称“本政策”/“本隐私政策”），帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。
                    </p>
                    <p>在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体/粗体下划线标识的条款，确保您充分理解和同意之后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。
                    </p>
                    <p>请在使用/继续使用我们的产品与/或服务前，仔细阅读并充分理解本政策，并在需要时，按照本政策的指引，作出适当的选择。如果您不同意本政策的内容，将可能导致我们的产品与/或服务无法正常运行，或者无法达到我们拟达到的服务效果，您应立即停止访问/使用我们的产品与/或服务。您使用/继续使用我们提供的产品与/或服务的行为，都表示您充分理解和同意本隐私政策的全部内容。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>一、适用范围</h2>
                    <p>1.1本政策适用于智步云上模型网上交易平台的所有产品与/或服务统一适用的通用内容，当您使用我们的任何产品与/或服务时，本《隐私政策》即符合适用，但如该产品与/或服务单独设置了隐私协议的，单独的隐私条款优先适用；单独的隐私条款未提及的内容则适用本政策。但请您注意，本《隐私政策》不适用于以下情况：
                    </p>
                    <p>1.1.1为我们的产品与/或服务提供广告服务的第三方的信息收集/处理做法。
                    </p>
                    <p>1.1.2我们的产品与/或服务可能会包含或链接至第三方提供的信息与/或第三方服务(包括任何第三方应用、网站、产品、服务等)，这些信息与/或服务由第三方负责运营，您使用该信息与/或服务与我们无关。我们在此善意地提醒您，您在使用第三方信息与/或服务时，应留意和仔细阅读第三方向您展示的相关用户协议和隐私政策，并妥善保管和谨慎提供您的个人信息。本《隐私政策》仅适用于我们所收集的您的个人信息，并不适用于任何第三方对您的个人信息的收集，以及任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方收集、储存和使用的您个人信息的行为在法律允许的范围内亦不承担任何责任。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>二、信息收集及使用</h2>
                    <p>2.1在您使用我们的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：</p>
                    <p>2.1.1为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；</p>
                    <p>2.1.2为实现向您提供我们产品及/或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，不会影响您使用我们的基本功能。
                    </p>
                    <p>2.1.3我们在此特别提醒您：我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，故基本/附加功能及对应收集使用的个人信息类型、范围会有所区别，请以具体的产品/服务功能为准。
                    </p>
                    <p>2.3我们会为您提供的各项具体功能场景包括：</p>
                    <p>2.3.1我们基于智步云上模型网上交易平台平台账户为您提供服务。为了创建智步云上模型网上交易平台平台账户您需要至少向我们提供您的手机号码、拟使用的会员名和密码。如果您拒绝提供上述信息，您将无法注册智步云上模型网上交易平台平台账户，仅可以使用浏览服务。
                    </p>
                    <p>2.3.2为了确保我们是在为您本人提供服务，我们可能会根据您提供的上述信息校验您的身份。若存在依法需确定您必要身份的场景（包括依法保护未成年人权益、打击电信网络诈骗、为您扣缴税费、行政执法或司法诉讼中相关主体认定）时，您授权我们可获取您对应支账户的必要认证信息用于上述目的。
                    </p>
                    <p>2.3.3我们会根据您的智步云上模型网上交易平台平台账户使用情况及平台设置的账户等级计算规则确定您当前的等级，并为您提供相应账户等级所对应的基本权益。</p>
                    <p>2.4附加用户服务</p>
                    <p>2.4.1特别用户权益：如果您选择填写真实姓名、性别、出生日期、居住地、昵称、头像，我们可以为您提供会员特权服务。其中，您设置的昵称和头像，将公开显示。</p>
                    <p>2.4.2实人认证：您可以根据认证要求提交相应的身份证件信息或者面部信息以完成实人认证。</p>
                    <p>2.4.3授权登录：我们可能经您单独同意后向第三方提供您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或第三方处直接登录。此外，我们可能会根据您的单独同意从第三方处获取您的第三方账户信息，并与您的智步云上模型网上交易平台平台账户进行绑定，使您可在第三方处直接登录、使用我们的产品及/或服务。我们将在您单独同意的授权范围内使用您的相关信息。
                    </p>
                    <p>2.4.4其他用户角色服务：如果您申请注册成为卖家、服务商或其他存在额外身份认证要求的会员角色，您需主动向我们提供身份信息及/或企业相关信息，或授权我们自支付宝公司处获取您对应支付宝账户的上述相关认证信息，用于您身份及其他会员角色获取资格的核验、登记、公示及其他我们明确告知的目的。
                    </p>
                    <p>2.4.5如果您已拥有智步云上模型网上交易平台平台账户，我们可能会在智步云上模型网上交易平台平台服务中显示您的上述个人信息，以及您在智步云上模型网上交易平台平台上或与智步云上模型网上交易平台平台账户相关联的产品和服务中执行的操作（您可通过智步云上模型网上交易平台平台账户在我们网站或者客户端提供的链接入口或其他产品/服务入口使用我们及/或关联公司提供的产品或服务），包括通过智步云上模型网上交易平台平台账户集中展示您的个人资料、优惠权益、交易订单。我们会尊重您对智步云上模型网上交易平台平台服务和智步云上模型网上交易平台平台账户设置所做的选择。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>三、向您展示商品或服务信息</h2>
                    <p>为向您展示商品或服务信息，包括您的访问足迹、历史搜索情况，我们会收集和使用您在访问或使用智步云上模型网上交易平台平台网站或客户端时的浏览、搜索记录。我们会结合依法收集的设备信息、服务日志信息，以及其他取得您授权的信息，通过算法模型预测您的偏好特征，匹配您可能感兴趣的商品、服务或其他信息，对向您展示的商品、服务或其他信息进行排序。为满足您的多元需求，我们会在排序过程中引入多样化推荐技术，拓展推荐的内容，避免同类型内容过度集中。我们也会基于您的偏好特征在智步云上模型网上交易平台及其他第三方应用程序向您推送您可能感兴趣的商业广告及其他信息，或者向您发送商业性短信息。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>四、为您提供收藏、加购、关注与分享功能</h2>
                    <p>在您浏览我们网站或客户端的过程中，您可以选择对感兴趣的商品及/或服务进行收藏、添加至购物车、与您感兴趣的商家/品牌/其他会员建立关注关系、通过我们提供的功能组件向第三方分享商品/服务信息。在您使用上述功能的过程中，我们会收集包括您的收藏及添加购物车的记录、关注关系、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。您可以在收藏夹、购物车查看或管理您的收藏和加购信息。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>五、帮助您完成下单及订单管理</h2>
                    <p>5.1当您在我们的产品与/或服务中购买服务或课程的，我们需要根据服务或课程类型收集如下部分或全部的个人信息，包括：交易服务信息、采购课程信息、已购素材信息、收货人信息（收货人姓名、收货地址及其联系电话）（个人敏感信息）、交易金额、下单时间、订单类型、订单号、订单状态、支付方式、支付账号、订单状态（个人敏感信息），我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客户服务等。
                    </p>
                    <p>5.2当您浏览智步云上模型网上交易平台页面过程中，您可以选择将感兴趣的素材分享至第三方（微博、QQ空间、朋友圈）。为帮助您实现前述功能，在您使用前述功能过程中，我们会收集您的第三方分享记录。</p>
                    <p>5.3当您选择购买智步云上模型网上交易平台素材时，为帮助您顺利购买素材、保障您的交易安全、管理您的订单，我们会收集您的购买记录，包括商品名称、下单时间、订单金额、支付状态。前述信息您可以在：“交易-已购买”列表中查看。
                    </p>
                    <p>5.4当您浏览智步云上模型网上交易平台课程页面过程中，您可以选择将感兴趣的课程分享至第三方（微信、朋友圈、QQ、微博）。为帮助您实现前述功能，在您使用前述功能过程中，我们会收集您的第三方分享记录。</p>
                    <p>5.5当您选择购买智步云上模型网上交易平台学习课程，为帮助您顺利购买课程、保障您的交易安全、管理您的订单，我们会收集您的购买记录，包括下单时间、订单金额、课程信息、支付状态。前述信息您可以在：“课程-已购买”列表中查看。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>六、搜索功能</h2>
                    <p>当您使用搜索功能时，我们会自动收集您的一些信息，包括如下个人信息：搜索的字词、浏览记录和时间、搜索的时间。只有当您在搜索框中主动填入相关信息并点击搜索后，为了实现搜索功能我们会收集该信息。我们收集这些信息是为了向您提供您所需要的内容和可能更感兴趣的服务，同时亦可以改进我们的产品和服务.
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>七、帮助您完成支付</h2>
                    <p>7.1为完成订单支付，您需要选择付款方式。我们会将您的智步云上模型网上交易平台账户会员名、对应的支付宝账户会员名、订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在网站或客户端中嵌入的支付软件工具开发包（软件工具开发包在本政策中简称“SDK”）及其他安全方式。
                    </p>
                    <p>7.2为使我们及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务，您同意我们可自您所选择的交易对象、支付公司或您选择的其他金融机构处收集与支付进度相关信息。</p>
                </div>
                <div class="protocol-section">
                    <h2>八、客服及争议处理</h2>
                    <p>8.1当您与我们联系或提出售中、售后、争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的会员身份。</p>
                    <p>8.2为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信/通话记录及相关内容（包括账户信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账户信息和订单信息。
                    </p>
                    <p>8.3为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。</p>
                </div>
                <div class="protocol-section">
                    <h2>九、为您提供信息公开发布功能</h2>
                    <p>9.1您可通过我们为您提供的评论、问答、论坛、个人主页、及其他信息发布功能，选择公开发布图文/视频内容，发表评价及问答内容，以及作为卖家发布商品及/或服务相关信息、店铺相关信息。我们尊重并保护您对相关信息是否发布以及发布范围的设置。
                    </p>
                    <p>9.2我们可能会根据您的会员类型及网络日志信息，判断您是否可享受对应信息发布功能权限。</p>
                    <p>9.3请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至敏感个人信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及他人个人信息的，您需在发布前征得他人的同意。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十、为您提供安全保障</h2>
                    <p>为履行保障电子商务交易安全的法定义务，提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入风险，更准确地识别违反法律法规或智步云上模型网上交易平台相关协议、规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全SDK收集您的设备信息、服务日志信息，并可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息（其中，我们可能会在应用后台运行期间收集MAC地址、IMEI及其他设备标识符进行风险校验），来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十一、为您提供的其他附加服务</h2>
                    <p>11.1基于系统权限的附加服务</p>
                    <p>11.1.1为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会通过开启系统权限以收集和使用您的个人信息。如果您不同意开启相关权限，不会影响您使用智步云上模型网上交易平台的基本服务，但您可能无法获得这些附加服务给您带来的用户体验
                    </p>
                    <p>11.1.2请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
                    </p>
                    <p>11.2Cookie和同类技术的服务</p>
                    <p>11.2.1Cookie和同类设备信息标识技术是互联网中普遍使用的技术。当您使用我们的服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符（以下简称“Cookie”），以收集、标识和存储您访问、使用本产品时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie主要为了保障产品与服务的安全、高效运转，可以使我们确认您账户与交易的安全状态，排查崩溃、延迟的相关异常情况，帮助您省去重复您填写表单、输入搜索内容的步骤和流程。
                    </p>
                    <p>11.2.2同时，我们可能会利用Cookie向您展示您可能感兴趣的信息或功能，并优化您对广告的选择。大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以进行相应的数据清除操作，或可修改对Cookie的接受程度或拒绝我们的Cookie。您可能因为这些修改，无法使用依赖于Cookie的服务或相应功能。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十二、对外提供信息</h2>
                    <p>12.1我们不会与智步云上模型网上交易平台服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
                    <p>12.1.1履行法定义务所必需的共享：我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，共享您的个人信息。</p>
                    <p>12.1.2取得您同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
                    <p>12.1.3为订立、履行您作为一方当事人的合同所必需的情况下的共享：您通过智步云上模型网上交易平台平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。
                    </p>
                    <p>12.1.4与关联公司间共享：为便于我们与关联公司共同向您提供部分服务，基于智步云上模型网上交易平台账户向您提供产品和服务，推荐您可能感兴趣的信息，识别会员账户异常，保护智步云上模型网上交易平台关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束，如果我们共享您的敏感个人信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
                    </p>
                    <p>12.1.5特别提示：如果您在我们的智步云上模型网上交易平台平台上进行内容出售并通过平台与购买者直接完成交易，您将与我们的合作方在智步云上模型网上交易平台平台上签订一项协议，我们需要把您的信息提供给合作方，用于办理合作事宜，我们向您承诺，我们提供给合作方的您的个人信息，将限于合作事宜所必要范围，且将要求合作方对保护您的个人信息的相关事宜作出保证。
                    </p>
                    <p>12.1.6请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎地考虑并做出决定。</p>
                    <p>12.2委托处理</p>
                    <p>12.2.1我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其将单独征得您的同意。
                    </p>
                    <p>12.2.2目前，我们委托的授权合作伙伴包括以下类型：</p>
                    <p>12.2.2.1广告、分析服务类的授权合作伙伴。我们会在采用行业通用的安全技术前提下，委托这些合作伙伴处理与广告投放、覆盖面和有效性相关的信息。我们不会将您的个人身份信息委托合作伙伴处理。
                    </p>
                    <p>12.2.2.2供应商、服务提供商和其他合作伙伴。我们将信息委托给支持我们业务的供应商、服务提供商和其他合作伙伴处理，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、提供客户服务、支付便利或进行学术研究和调查。
                    </p>
                    <p>12.2.2.3为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。
                    </p>
                    <p>12.3转让</p>
                    <p>如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
                    </p>
                    <p>12.4公开披露</p>
                    <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
                    <p>12.4.1基于您的主动选择及其他单独同意的情况下，我们可能会公开披露您的个人信息；</p>
                    <p>12.4.2如果我们确定您出现违反法律法规或严重违反智步云上模型网上交易平台平台相关协议及规则的情况，或为保护智步云上模型网上交易平台平台用户或公众的人身财产安全免遭侵害，我们可能披露关于您的个人信息，包括相关违规行为以及智步云上模型网上交易平台平台已对您采取的措施。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十三、您的权利</h2>
                    <p>您可以通过以下方式查阅和管理您的信息，我们会在符合法律法规要求的情形下响应您的请求：</p>
                    <p>13.1查阅、更正和补充</p>
                    <p>您有权通过以下方式查阅、更正和补充您的信息：</p>
                    <p>13.1.1登录智步云上模型网上交易平台，进入“我的后台”，选择“个人设置”；</p>
                    <p>13.1.2登录智步云上模型网上交易平台选择“联系客服”。</p>
                    <p>13.2删除</p>
                    <p>您可以通过“（一）查阅、更正和补充您的信息”列明的路径删除您的部分信息，或申请注销账户删除您的全部信息。</p>
                    <p>在以下情形中，您可以通过与客服联系向我们提出删除个人信息的请求：</p>
                    <p>13.2.1如果我们处理个人信息的行为违反法律法规；</p>
                    <p>13.2.2如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
                    <p>13.2.3如果我们处理个人信息的行为严重违反了与您的约定；</p>
                    <p>13.2.4如果我们的处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
                    <p>13.2.5如果我们停止提供产品或者服务，或者保存期限已届满。</p>
                    <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</p>
                    <p>当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。
                    </p>
                    <p>13.3注销账户</p>
                    <p>您可以通过联系客服，申请注销您的账户：</p>
                    <p>在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除或匿名化处理您的个人信息。</p>
                    <p>13.4约束信息系统自动决策</p>
                    <p>在某些业务功能中，我们可能仅依据算法在内的非人工自动决策机制做出决定。如果这些决定影响您的合法权益，您可以通过客服联系我们。</p>
                    <p>13.5响应您的上述请求</p>
                    <p>13.5.1对于您或可能的您的监护人、近亲属及其他有权主体向我们提出上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您可以通过客服联系我们发起投诉。我们将在15天内做出答复。
                    </p>
                    <p>13.5.2为保障您的账户安全和您的个人信息安全，您向我们提出上述请求时，我们可能会先验证您的身份（如增加账户核验、要求您提供书面请求或其他合理方式），然后再处理您的请求。</p>
                    <p>13.5.3对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十四、信息的存储</h2>
                    <p>14.1存储期限</p>
                    <p>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要依据以下标准：
                    </p>
                    <p>14.1.1完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；</p>
                    <p>14.1.2保证我们为您提供服务的安全和质量；</p>
                    <p>14.1.3您是否同意更长的留存期间；</p>
                    <p>14.1.4是否存在关于保留期限的其他特别约定或法律法规规定。</p>
                    <p>在超出保留期间后，我们会根据适用法律的要求删除或匿名化处理您的个人信息。</p>
                    <p>14.2存储位置</p>
                    <p>我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行法律规定的义务后，向可能的境外实体提供您的个人信息：</p>
                    <p>14.2.1适用的法律有明确规定；</p>
                    <p>14.2.2获得您的单独同意；</p>
                    <p>14.2.3您作为一方当事人的跨境电子商务交易及其他类型合同订立和履行所必需的。针对以上情形，我们会按照本政策依法保护您的个人信息安全。</p>
                    <p>14.3存储安全</p>
                    <p>14.3.1数据保护技术措施</p>
                    <p>我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性，在您的浏览器与服务器之间交换数据时受SSL协议加密保护，我们提供HTTPS协议安全浏览方式；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
                    </p>
                    <p>14.3.2数据保护管理组织措施</p>
                    <p>我们建立了以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理及产品技术的维度提升个人信息的安全性。我们通过培训课程，不断加强员工对于保护个人信息重要性的认识。
                    </p>
                    <p>14.3.3个人信息安全事件的响应</p>
                    <p>如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理必要的措施，以尽可能降低对您个人的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将以短信、电话、推送通知及其他合理渠道告知您，难以逐一告知的，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
                    </p>
                    <p>14.3.4账户安全风险的防范</p>
                    <p>在使用智步云上模型网上交易平台服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息。此外，您也可以通过我们的服务与第三方建立沟通、交流信息或分析内容。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，不轻信通过其他交易工具进行交易，以免信息被窃取甚至遭遇电信网络诈骗。如您担心自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络智步云上模型网上交易平台客服以便我们根据您的申请采取相应措施。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十五、政策的更新</h2>
                    <p>15.1为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策以告知您具体的变化。但未经您明确同意，我们不会限制您按照本政策所享有的权利。我们会在专门页面上发布对本政策所做的任何变更。
                    </p>
                    <p>15.2对于重大变更，我们还会提供更为显著的通知（包括我们会通过智步云上模型网上交易平台公示的方式进行通知或向您提供弹窗提示）。</p>
                    <p>15.3本政策所指的重大变更包括但不限于：</p>
                    <p>15.3.1产品的业务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
                    <p>15.3.2业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</p>
                    <p>15.3.3个人信息共享或公开披露的主要对象发生变化；</p>
                    <p>15.3.4用户个人信息权利及其行使方式发生重大变化；</p>
                    <p>15.3.5处理个人信息保护负责人的联络方式及投诉渠道发生变化时；</p>
                    <p>15.3.6个人信息保护影响评估报告表明产品存在对个人权益有重大影响时。</p>
                </div>
                <div class="protocol-section">
                    <h2>十六、未成年人保护</h2>
                    <p>16.1在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。
                    </p>
                    <p>16.2若您是儿童的父母或其他监护人，请您关注儿童是否是在取得您的授权同意之后使用我们的服务。如您对儿童的个人信息有疑问，请与我们联系。</p>
                </div>
                <div class="protocol-section">
                    <h2>十七、联系我们</h2>
                    <p>17.1您可以通过以下方式与我们联系，我们将在15天内回复您的请求：</p>
                    <p>17.1.1如您对本政策内容有任何疑问、意见或建议，您可通过智步云上模型网上交易平台客服与我们联系；</p>
                    <p>17.1.2您可以通过【zhibuyunshang@swocs.com.cn】与其联系（请您注明与【智步云上模型网上交易平台】有关，并说明具体事实情况）。需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题。
                    </p>
                    <p>17.2附录：相关定义</p>
                    <p>智步云上模型网上交易平台：指智步云上模型网上交易平台（域名为http://swocs.com.cn/model/）网站及智步云上模型网上交易平台客户端。</p>
                    <p>智步云上模型网上交易平台服务提供者：指智步云上模型网上交易平台的互联网信息及软件技术服务提供者北京智步云上科技有限公司。</p>
                    <p>关联公司：指披露的智步云上模型网上交易平台服务提供者的关联公司。</p>
                    <p>个人信息：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息,不包括匿名化处理后的信息。</p>
                    <p>敏感个人信息：敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。</p>
                    <p>儿童：指不满十四周岁的未成年人。</p>
                    <p>设备信息：包括设备标识符（IMEI、IDFA、AndroidID、MAC、OAID、IMSI及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息），设备网络环境信息（IP地址，WiFi信息，基站信息及其他网络相关信息）。以产品实际采集情况为准。
                    </p>
                    <p>服务日志信息：包括浏览记录、点击查看记录、搜索查询记录、收藏、添加至购物车、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。</p>
                    <p>去标识化：指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</p>
                    <p>匿名化：指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
                </div>
                <!-- 更多协议内容... -->
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'PrivacyPolicy',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>